// Generated file; do not edit. See https://github.com/stencila/stencila/tree/main/rust/schema-gen

export type NodeType =
  | "Null"
  | "Boolean"
  | "Integer"
  | "UnsignedInteger"
  | "Number"
  | "String"
  | "Cord"
  | "Array"
  | "Admonition"
  | "ArrayHint"
  | "ArrayValidator"
  | "Article"
  | "AudioObject"
  | "AuthorRole"
  | "BooleanValidator"
  | "Brand"
  | "Button"
  | "CallArgument"
  | "CallBlock"
  | "Cite"
  | "CiteGroup"
  | "Claim"
  | "CodeBlock"
  | "CodeChunk"
  | "CodeExpression"
  | "CodeInline"
  | "CodeLocation"
  | "Collection"
  | "Comment"
  | "CompilationDigest"
  | "CompilationMessage"
  | "ConstantValidator"
  | "ContactPoint"
  | "CreativeWork"
  | "Datatable"
  | "DatatableColumn"
  | "DatatableColumnHint"
  | "DatatableHint"
  | "Date"
  | "DateTime"
  | "DateTimeValidator"
  | "DateValidator"
  | "DefinedTerm"
  | "DeleteBlock"
  | "DeleteInline"
  | "Directory"
  | "Duration"
  | "DurationValidator"
  | "Emphasis"
  | "EnumValidator"
  | "Enumeration"
  | "ExecutionDependant"
  | "ExecutionDependency"
  | "ExecutionMessage"
  | "ExecutionTag"
  | "Figure"
  | "File"
  | "ForBlock"
  | "Form"
  | "Function"
  | "Grant"
  | "Heading"
  | "IfBlock"
  | "IfBlockClause"
  | "ImageObject"
  | "IncludeBlock"
  | "InsertBlock"
  | "InsertInline"
  | "InstructionBlock"
  | "InstructionInline"
  | "InstructionMessage"
  | "IntegerValidator"
  | "Link"
  | "List"
  | "ListItem"
  | "MathBlock"
  | "MathInline"
  | "MediaObject"
  | "ModifyBlock"
  | "ModifyInline"
  | "ModifyOperation"
  | "MonetaryGrant"
  | "Note"
  | "NumberValidator"
  | "ObjectHint"
  | "Organization"
  | "Paragraph"
  | "Parameter"
  | "Periodical"
  | "Person"
  | "PostalAddress"
  | "Product"
  | "PropertyValue"
  | "PublicationIssue"
  | "PublicationVolume"
  | "QuoteBlock"
  | "QuoteInline"
  | "ReplaceBlock"
  | "ReplaceInline"
  | "Review"
  | "Section"
  | "SoftwareApplication"
  | "SoftwareSourceCode"
  | "Strikeout"
  | "StringHint"
  | "StringOperation"
  | "StringPatch"
  | "StringValidator"
  | "Strong"
  | "StyledBlock"
  | "StyledInline"
  | "Subscript"
  | "Superscript"
  | "Table"
  | "TableCell"
  | "TableRow"
  | "Text"
  | "ThematicBreak"
  | "Thing"
  | "Time"
  | "TimeValidator"
  | "Timestamp"
  | "TimestampValidator"
  | "TupleValidator"
  | "Underline"
  | "Unknown"
  | "Variable"
  | "VideoObject"
  | "Object";

export const NodeTypeList = [
  "Null",
  "Boolean",
  "Integer",
  "UnsignedInteger",
  "Number",
  "String",
  "Cord",
  "Array",
  "Admonition",
  "ArrayHint",
  "ArrayValidator",
  "Article",
  "AudioObject",
  "AuthorRole",
  "BooleanValidator",
  "Brand",
  "Button",
  "CallArgument",
  "CallBlock",
  "Cite",
  "CiteGroup",
  "Claim",
  "CodeBlock",
  "CodeChunk",
  "CodeExpression",
  "CodeInline",
  "CodeLocation",
  "Collection",
  "Comment",
  "CompilationDigest",
  "CompilationMessage",
  "ConstantValidator",
  "ContactPoint",
  "CreativeWork",
  "Datatable",
  "DatatableColumn",
  "DatatableColumnHint",
  "DatatableHint",
  "Date",
  "DateTime",
  "DateTimeValidator",
  "DateValidator",
  "DefinedTerm",
  "DeleteBlock",
  "DeleteInline",
  "Directory",
  "Duration",
  "DurationValidator",
  "Emphasis",
  "EnumValidator",
  "Enumeration",
  "ExecutionDependant",
  "ExecutionDependency",
  "ExecutionMessage",
  "ExecutionTag",
  "Figure",
  "File",
  "ForBlock",
  "Form",
  "Function",
  "Grant",
  "Heading",
  "IfBlock",
  "IfBlockClause",
  "ImageObject",
  "IncludeBlock",
  "InsertBlock",
  "InsertInline",
  "InstructionBlock",
  "InstructionInline",
  "InstructionMessage",
  "IntegerValidator",
  "Link",
  "List",
  "ListItem",
  "MathBlock",
  "MathInline",
  "MediaObject",
  "ModifyBlock",
  "ModifyInline",
  "ModifyOperation",
  "MonetaryGrant",
  "Note",
  "NumberValidator",
  "ObjectHint",
  "Organization",
  "Paragraph",
  "Parameter",
  "Periodical",
  "Person",
  "PostalAddress",
  "Product",
  "PropertyValue",
  "PublicationIssue",
  "PublicationVolume",
  "QuoteBlock",
  "QuoteInline",
  "ReplaceBlock",
  "ReplaceInline",
  "Review",
  "Section",
  "SoftwareApplication",
  "SoftwareSourceCode",
  "Strikeout",
  "StringHint",
  "StringOperation",
  "StringPatch",
  "StringValidator",
  "Strong",
  "StyledBlock",
  "StyledInline",
  "Subscript",
  "Superscript",
  "Table",
  "TableCell",
  "TableRow",
  "Text",
  "ThematicBreak",
  "Thing",
  "Time",
  "TimeValidator",
  "Timestamp",
  "TimestampValidator",
  "TupleValidator",
  "Underline",
  "Unknown",
  "Variable",
  "VideoObject",
  "Object",
];
